import BasicReadField from './BasicReadField';
import { withRouter } from 'react-router-dom';
import SchemeChip from '../vocabulary/core/SchemeChip';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import { default as React } from 'react';
import CancelButton from './CancelButton';
import { globalStyles as styles } from './style/gstheme';
import TitledPanel from './TitledPanel';
import ExternalTypeLink from './ExternalTypeLink';
import { Typography } from '@material-ui/core';
import { computeApplicationPathFromType, computeLinkFromType, getProjectFromGraph } from './utils/utils';

const titleProps = ["title", "prefLabel", "literalForm", "title", "title", "title", "label",
    "label", "label", "label", "label", "title", "label"];

class InfoLinkDialog extends React.Component {

    state = {
        open: true
    };

    exitInfoDialog = () => {
        this.setState({ open: false });
        this.props.onClose();
    };

    render() {

        const { classes, linkList, defaultLang, graph, validType, data, onToggleView } = this.props;
        const { open } = this.state;

        let label = validType;
        switch (validType) {
            case "ConceptScheme":
                label = "Concept Scheme";
                break;
            case "OrderedCollection":
                label = "Ordered Collection";
                break;
            case "OwlClass":
                label = "Class";
                break;
            case "ObjectProperty":
                label = "Object Property";
                break;
            case "DatatypeProperty":
                label = "Datatype Property";
                break;
            case "AnnotationProperty":
                label = "Annotation Property";
                break;
            case "NamedIndividual":
                label = "Named Individual";
                break;
            default: label = validType;
        }
        const typeList = ["ConceptScheme", "Concept", "Label", "Collection", "OrderedCollection",
            "Ontology", "OwlClass", "ObjectProperty", "DatatypeProperty", "AnnotationProperty", "NamedIndividual",
            "Dataset", "Resource"];
        const typeIndex = typeList.findIndex(typeItem => data.type.includes(typeItem));
        const titleProp = titleProps[typeIndex];

        const isDeleted = "pendingDeletion" in data;
        const displayLang = data[titleProp] && data[titleProp][defaultLang] ?
            defaultLang
            :
            data[titleProp] && data[titleProp]["und"] ?
                "und"
                :
                defaultLang;
        const title = data[titleProp] && data[titleProp][displayLang] ?
            Array.isArray(data[titleProp][displayLang]) ?
                data[titleProp][displayLang].join(" AND ")
                :
                data[titleProp][displayLang]
            :
            "";

        return (
            <React.Fragment>
                <Dialog
                    data-test="info-link-dialog"
                    maxWidth="md"
                    fullWidth
                    classes={{
                        paper: classes.paper,
                        paperWidthMd: classes.mediumDialog
                    }}
                    open={open}
                    onClose={this.exitInfoDialog}
                    aria-labelledby="info-link-dialog-title">
                    <DialogTitle disableTypography className={classes.mainHeading} id="info-link-dialog-title">Resource Detail</DialogTitle>
                    <DialogContent>
                        <TitledPanel dataTest="resource-type" title="Type">
                            <ExternalTypeLink
                                id={validType}
                                label={label}
                                graph={graph}
                                isReadOnly={true}
                            />
                        </TitledPanel>
                        <TitledPanel margin dataTest="resource-type" title="Title">
                            <BasicReadField dataTest="resource-title" text={title} lang={displayLang} fullWidth />
                            {isDeleted &&
                                <Typography data-test="link-is-deleted" variant="body2">This resource is pending deletion.</Typography>
                            }
                        </TitledPanel>
                        {linkList && linkList.length > 0 && !isDeleted &&
                            <TitledPanel dataTest="schemes" margin title="View In (Ctrl+Click to Open in New Tab)">
                                {linkList.map(linkIRI => {
                                    const projectIRI = getProjectFromGraph(this.props.graph);
                                    let link = computeLinkFromType(validType, this.props.data.id, linkIRI, projectIRI);
                                    return <SchemeChip
                                        key={linkIRI}
                                        id={linkIRI}
                                        exitOnNewTab={this.exitInfoDialog}
                                        onLink={() => {
                                            this.exitInfoDialog();
                                            if (onToggleView) onToggleView();
                                        }}
                                        viewLang={defaultLang}
                                        defaultLang={defaultLang}
                                        isReadOnly={true}
                                        graph={graph}
                                        link={computeApplicationPathFromType(validType) + link} />;
                                })}
                            </TitledPanel>
                        }
                    </DialogContent>
                    <DialogActions className={classes.dialogActions}>
                        <CancelButton onClick={this.exitInfoDialog}>Close</CancelButton>
                    </DialogActions>
                </Dialog>
            </React.Fragment>
        );
    }
}

InfoLinkDialog.propTypes = {
    linkList: PropTypes.array.isRequired,
    defaultLang: PropTypes.string.isRequired,
    onToggleView: PropTypes.func,
    validType: PropTypes.string.isRequired,
    graph: PropTypes.string.isRequired,
    data: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    onClose: PropTypes.func.isRequired,
    classes: PropTypes.object
};

export default withRouter(withStyles(styles)(InfoLinkDialog));